




























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup, List } from 'vant';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import { userList, userDel, userHelper, getUserType } from './api/index';
import ListItem from './components/ListItem.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button)
  .use(List);
enum EUserStatus {
  'unRegistered' = 201,
  'reviewing' = 202,
  'reviewed' = 203,
}
@Component({
  components: {
    ListItem,
  },
})
export default class User extends Vue {
  option = config.OPTHINES;
  userStatus: any = null;
  showModal = false;
  userList: any[] = [];
  createDate: any[] = [];
  showUserList = true;
  pointOut = false;
  loading = false;
  finished = false;
  page = 1;
  get source() {
    return this.$route.params.source;
  }
  public created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    // userHelper().then((res) => console.log('访问userHelper'));
    // 分享
    appShare({
      title: '山城榜样说',
      url: window.location.href,
      subtitle: '聆听TA的故事，传承榜样精神',
      classId: -1,
      id: -1,
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '山城榜样说',
      subtitle: '聆听TA的故事，传承榜样精神',
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
    });
  }
  onLoad() {
    userList(this.page).then((res: any) => {
      this.successGetUser(res);
    });
  }
  public successGetUser(res: any) {
    console.log(res.code);
    switch (res.code) {
      case 100:
        this.showUserList = false;
        // if (!window.udid) {
        if (isWeiXin()) {
          Dialog.confirm({
            title: '友情提示',
            message: '请在上游新闻App进行上传作品',
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            overlay: true,
            closeOnClickOverlay: false,
          })
            .then(() => {
              window.location.href =
                'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
            })
            .catch(() => {
              if (isWeiXin() === true) {
                this.pointOut = true;
              } else {
                window.location.href =
                  'shangyounews://{"dt":"7","url":"' +
                  document.location.href +
                  '"}';
              }
            });
        } else if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 200:
        if (this.page === 1 && res.data.length === 0) {
          this.showUserList = false;
        } else {
          console.log('res.data', res.data);
          this.page = this.page + 1;
          if (!res.data || res.data.length === 0) {
            this.finished = true;
          } else {
            this.userList = [...this.userList, ...res.data];
          }
          this.loading = false;
          // 时间格式转换
          for (const timeItem of res.data) {
            const date = new Date();
            date.setTime(timeItem.createtime * 1000);
            // const year = date.getYear();
            const month = date.getMonth() + 1;
            const d = date.getDate();
            this.createDate.push(month + '-' + d);
          }
        }
    }
  }
  public handleDel(id: any) {
    Dialog.confirm({
      title: '提示',
      message: '你确定要删除吗？',
    })
      .then(() => {
        userDel(id).then((res) => this.successDelete(res));
      })
      .catch(() => {
        console.log('取消删除');
      });
  }
  // 删除成功
  public successDelete(res: any) {
    if (res.code === 200) {
      Toast('删除成功！');
      setTimeout(() => {
        this.$router.go(0);
      }, 1000);
    }
  }
  // public enterUploading() {
  //   // 直接跳转页面
  //   window.location.href = 'https://wap.cqcb.com/shangyou_news/composition';
  // }
  public enterUploading() {
    if (window.gettoken() && window.gettoken() !== 'null') {
      // 判断该作文用户状态
      getUserType().then((res) => this.enterUserType(res));
    } else {
      // 用户未登录
      // console.log('用户未登录', getClientInfo(), window.version);
      if (parseFloat(window.version) >= 4.5) {
        const option = {
          action: 'mUserLogin',
          data: '请先登录上游账号',
        };
        window.handleMessage(JSON.stringify(option));
      } else {
        window.location.href = 'client:logout';
      }
    }
  }
  public enterUserType(res: any) {
    console.log('res.statusCode', res.statusCode);
    this.userStatus = Number(res.statusCode);

    if (this.userStatus === EUserStatus.unRegistered) {
      // 未注册作文用户前往作文注册页面
      console.log('不是作文用户');
      Toast('请完善作文用户资料');
      setTimeout(() => {
        window.location.href =
          'https://wap.cqcb.com/shangyou_news/composition/UserCenter';
      }, 200);
    } else if (this.userStatus === EUserStatus.reviewing) {
      // 审核状态弹窗提示账户审核中，无法上传作文
      this.toggleDialog();
    } else if (this.userStatus === EUserStatus.reviewed) {
      // 账号审核通过，跳转至发布作文页面
      console.log('是作文用户');
      window.location.href =
        'https://wap.cqcb.com/shangyou_news/composition/contribute';
    }
  }
  public toggleDialog() {
    this.showModal = !this.showModal;
  }
}
